import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TAIGA_UI_MODULES } from 'app/@taiga-modules';
import { CurrencyExchangePipe, RoundPipe } from 'app/widget/index.pipes';
import { selectDatesAndAccupancy, selectHotelBookingData } from 'app/widget/state';
import { ENGINES_TRANSLATIONS } from 'app/widget/state/index.types';
import { OccupancyInfoComponent } from '../occupancyInfo/occupancyInfo.component';
import { CanAccommodateOccupancy } from 'app/helpers';

@Component({
  selector: 'app-ota-prices',
  standalone: true,
  imports: [
    CommonModule, 
    TranslateModule, 
    RouterLink, 
    ...TAIGA_UI_MODULES,
    CurrencyExchangePipe,
    OccupancyInfoComponent
  ],
  templateUrl: './otaPrices.component.html',
  styleUrl: './otaPrices.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtaPricesComponent implements OnInit {

  store$ = inject(Store);
  selectHotelBookingData$ = this.store$.select(selectHotelBookingData)
  selectDatesAndAccupancy$ = this.store$.select(selectDatesAndAccupancy)

  TRANSLATIONS = ENGINES_TRANSLATIONS
  CanAccommodateOccupancy = CanAccommodateOccupancy

  ngOnInit(): void { }

}
